import { $journalApi } from "@/entities/journal/fetch/fetch-client";

export const usePostSignEntryPartOne = () =>
  $journalApi.useMutation(
    "post",
    "/api/v1/journals/section-four/{sectionFourListId}/items/{itemNoVersionId}/itemPartOne/{itemPartOneId}/sign/done",
  );
